<template>
    <fade-transition :duration="1000"
                     mode="out-in">
        <router-view/>
    </fade-transition>
</template>
<script>
        import {FadeTransition} from 'vue2-transitions';

        export default {
                components: {
                        FadeTransition
                }
        };
</script>